















































































































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import wxImgTextImgEdit from "../tenantsView/wx-message_TextImgEdit.vue"; //图文回复回复表单
//import wxImgTextImgEditWx from "../tenantsView/weChat-graphic_edit.vue"; //图文回复回复表单(同步微信编辑)
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";

//import App from "@/components/Global/GetAppData"; //缓存接口
import { log } from "util";
import { WxTextImg } from "@/Entity"; //全局常量
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: { wxImgTextImgEdit }
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Provide()
  private pagesize = 10; //每页的数据条数
  private pageIndex = 1; // 默认第一页
  private inboxTabData: any = [];
  private totalItem = 0; //数据总长度
  private Keyword = ""; //搜索
  private Data = {}; //把行信息传到子组件
  private TextImgEdit = true;
  private loading = false; //加载数据
  private ImgTextTabData = [];
  private loadingText = "数据正在同步中，请稍后.....";
  private Nature: string = "";
  private State: string = ""; //状态
  private scrollHeight = 500; //当前高度
  private GetAppData: any = []; //取应用号信息
  private switchType = false;
  private switchNature = true;
  private switchState = true;
  //配置关键词
  private dialogFormVisible = false;
  private dialogFormTitle = "";
  private AddaccountFormKeyword = "";
  private AddaccountFormType = 0;
  private FormData: any; //定义数据在WxTextImg里
  //方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.getTextList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = val;
    this.getTextList();
  }
  //格式化状态
  formatState(row: any, column: any) {
    switch (row.State) {
      case 1:
        return "启用";
      case 0:
        return "禁用";
      case -1:
        return "删除";
    }
  }
  //新增文本回复
  AddImgTextEdit() {
    this.TextImgEdit = false;
    this.Data = new WxTextImg();
  }
  handleEdit(row: any) {
    if (row.Nature == 1 && row.MediaId) {
      //编辑永久素材
      this.$router.push(
        "/tenants/tenantsView/weChat-graphic_edit?id=" + row.GraphicId
      );
    } else {
      this.Data = row; //把行信息传给data
      this.TextImgEdit = false;
    }
  }
  //素材类型
  formatNature(row: any, column: any) {
    if (row.Nature == `1`) {
      return `永久素材`;
    } else {
      return `临时素材`;
    }
  }
  //是否开启打赏功能
  formatReward(row: any, column: any) {
    if (row.Nature == 1) {
      if (row.Reward == `1`) {
        return `开启`;
      } else {
        return `关闭`;
      }
    } else {
      return "无";
    }
  }
  //是否开启评论
  formatComment(row: any, column: any) {
    if (row.Nature == 1) {
      if (row.Comment == `1`) {
        return `开启`;
      } else {
        return `关闭`;
      }
    } else {
      return "无";
    }
  }
  //格式化是否同步
  Synchronize(row: any, column: any) {
    if (row.Nature == 1) {
      if (row.Synchronize == 1) {
        return "(<font color=green>已同步</font>)" + row.GraphicTitle;
      } else {
        return "(<font color=red>未同步</font>)" + row.GraphicTitle;
      }
    } else {
      return row.GraphicTitle;
    }
  }
  //关注显示
  formatFollowDisplay(row: any, column: any) {
    if (row.Nature == 1) {
      if (row.FollowDisplay == `1`) {
        return `开启`;
      } else {
        return `关闭`;
      }
    } else {
      return "无";
    }
  }
  //详细页是否显示封面
  formatDetailImage(row: any, column: any) {
    if (row.Nature == 1) {
      if (row.DetailImage == `0`) {
        return `隐藏`;
      } else {
        return `显示`;
      }
    } else {
      return "无";
    }
  }
  //格式化时间
  formatDate(row: any, column: any) {
    if (row.UpdaterDate != null && row.UpdaterDate != "") {
      // var date = new Date(row.UpdaterDate);
      // return FomatDataStr.formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      var date = row.UpdaterDate;
      date = date.replace("T", " ");
      date = date.substring(0, 16);
      return date;
    } else {
      return "";
    }
  }

  //格式化匹配度类型
  formatStatus(row: any, column: any) {
    switch (row.Type) {
      case 0:
        return "包含匹配";
      case 1:
        return "完全匹配";
      default:
        return "";
    }
  }

  //查询方法
  Inquire() {
    this.getTextList();
  }
  //表单过来的刷新方法
  refresh() {
    this.getTextList();
    this.TextImgEdit = true;
  }
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj: any) => {
      that.GetAppData.Aid = obj.Aid;
      that.getTextList();
    });
    this.getTextList();
  }
  //查看文章
  handleView(index: any, row: any) {
    console.log(row.UrlLink);

    if (row.UrlLink) {
      //window.open(row.UrlLink);
      window.open(row.UrlLink, "newwin");
    } else {
      this.$message.error("请先拉取新最文章！");
    }
  }
  //加载表格数据
  //同步微信图文
  async GetNewsMediaListAsync(type: any) {
    this.$confirm("拉取素材前会删除本地的永久素材确定要操作?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      this.loadWxData(type);
    });
  }
  //同步微信素材
  async loadWxData(type: any) {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      this.loadingText = "数据正在拉取中，请稍后.....";
      let params: any = {
        Input: [
          {
            Name: "SearchAccountDTO",
            Value: {
              aid: AppAccount.Aid,
              TenantID: AppAccount.TenantID
            }
          },
          {
            Name: "type",
            Value: type
          }
        ]
      };
      var res: any = await httpApi.PermanentMaterialList(params);
      //console.log(res);
      this.loading = false;
      if (res.ErrorCode == 0) {
        this.$message.success("拉取成功！");
        this.getTextList();
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //推送图文到微信公众号
  async UpdateNewsMediaListAsync() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      this.loadingText = "数据正在推送中，请稍后.....";
      let params: any = {
        Input: [
          {
            Name: "aid",
            Value: AppAccount.Aid
          }
        ]
      };
      var res: any = await httpApi.UpdateNewsMediaListAsync(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        this.loadWxData(2);
        //this.getTextList();
      } else {
        this.$message.error(res.ErrorMessage);
      }
      //console.log(res);
    }
  }
  //加载分页数据
  loadData() {
    // if (this.ImgTextTabData) {
    //   this.inboxTabData = this.ImgTextTabData.slice(
    //     (this.pageIndex - 1) * this.pagesize,
    //     this.pageIndex * this.pagesize
    //   );
    // }
    this.inboxTabData = this.ImgTextTabData;
    this.scrollHeight = document.body.scrollHeight - 430;
  }
  //加载数据
  async getTextList() {
    var _this = this;
    //console.log(this.GetAppData);
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      //搜索的数据 传参
      let params: any = {
        Input: [
          { Name: "aid", value: AppAccount.Aid },
          { Name: "type", value: "Single" },
          { Name: "Nature", value: this.Nature },
          { Name: "Keyword", value: this.Keyword },
          //分页参数
          { Name: "page", value: this.pageIndex },
          { Name: "rows", value: this.pagesize }
        ]
      };
      if (this.State) {
        params.Input.push({ Name: "State", value: this.State });
      }
      //console.log(params);
      var res: any = await httpApi.GetWxImgText(params);
      //console.log(res);

      this.loading = false;
      if (res.ErrorCode == 0) {
        _this.ImgTextTabData = res.output[0].value;
        //console.log("图文数据", _this.ImgTextTabData);
        //前端搜索
        // if (_this.Keyword) {
        //   _this.ImgTextTabData = res.output[0].value.filter(
        //     (x: {
        //       Keyword: {
        //         toUpperCase: () => { indexOf: (arg0: string) => number };
        //       };
        //     }) =>
        //       x.Keyword.toUpperCase().indexOf(
        //         _this.Keyword.trim().toUpperCase()
        //       ) != -1
        //   );
        // }
        _this.totalItem = res.output[1].value; //_this.ImgTextTabData.length;
        this.loadData();
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //配置关键词
  handlewords(index: any, row: any) {
    this.dialogFormVisible = true;
    this.FormData = row;
    this.dialogFormTitle = row.GraphicTitle;
    this.AddaccountFormKeyword = row.Keyword;
    this.AddaccountFormType = row.Type;
  }
  //保存关键词
  async seaveKeyword() {
    if (!this.AddaccountFormKeyword) {
      this.$message.warning("请输入关键词！");
      return;
    }
    this.FormData.ActionName = "UPDATE"; //修改方法
    this.FormData.Type = this.AddaccountFormType;
    this.FormData.Keyword = this.AddaccountFormKeyword;

    let params: any = {
      Input: [
        {
          Name: "AppReplyGraphicDTO",
          value: this.FormData
        }
      ]
    };
    console.log(params);
    var res: any = await httpApi.SaveWxImgText(params);
    if (res.ErrorCode == 0) {
      this.$message.success("保存关键词成功!");
      this.dialogFormVisible = false;
    } else {
      this.$message.error("保存关键词失败：" + res.ErrorMessage);
      return;
    }
  }
  //单行删除
  async handleDel(index: any, row: any) {
    this.$confirm("确定要删除当前数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      let model = row as WxTextImg; //把行内信息转换成wxText
      var _this = this;
      let AppAccount = this.GetAppData;

      if (AppAccount) {
        model.ApplicationId = AppAccount.Aid;
        model.TenantId = AppAccount.TenantID;
        model.ActionName = "DELETE";
        let params: any = {
          Input: [
            {
              Name: "AppReplyGraphicDTO",
              value: model
            }
          ]
        };
        this.loading = true;
        var res: any = await httpApi.SaveWxImgText(params);
        this.loading = false;
        if (res.ErrorCode == 0) {
          this.$message.success("删除成功!");
          this.getTextList();
        } else {
          this.$message.error(res.ErrorMessage);
        }
      }
      return new WxTextImg();
    });
  }
  //微信素材库也同步删除
  async handleDelAll(index: any, row: any) {
    this.$confirm("确定要删除当前数据，微信也同步删除确定要操作吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      let model = row as WxTextImg; //把行内信息转换成wxText
      var _this = this;
      let AppAccount = this.GetAppData;

      if (AppAccount) {
        model.ApplicationId = AppAccount.Aid;
        model.TenantId = AppAccount.TenantID;
        model.ActionName = "DELETE";
        let params: any = {
          Input: [
            {
              Name: "AppReplyGraphicDTO",
              value: model
            },
            {
              Name: "action",
              value: "AllDelete"
            }
          ]
        };
        this.loading = true;
        var res: any = await httpApi.SaveWxImgText(params);
        this.loading = false;
        if (res.ErrorCode == 0) {
          this.$message.success("删除成功!");
          this.getTextList();
        } else {
          this.$message.error(res.ErrorMessage);
        }
      }
      return new WxTextImg();
    });
  }
}
